(function () {
  if (window.__AG_PB_PD_VARIANTS_INIT__) return;
  window.__AG_PB_PD_VARIANTS_INIT__ = true;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  // ?type=otp — one-time-purchase-only landing pages. Overwrite each card's
  // "real" data-* with its OTP-equivalent (no selling plan) so every downstream
  // reader (syncFromCard, ATC's own init) sees one-time pricing with no extra code.
  function isOtpMode() {
    try {
      return new URLSearchParams(location.search).get('type') === 'otp';
    } catch (e) {
      return false;
    }
  }

  function applyOtpToCard(card) {
    var otpPrice = card.getAttribute('data-price-per-otp') || '';
    var otpCompare = card.getAttribute('data-compare-total-otp') || '';

    card.setAttribute('data-selling-plan', '');
    card.setAttribute('data-price-total', card.getAttribute('data-price-total-otp') || '');
    card.setAttribute('data-compare-total', card.getAttribute('data-compare-total-otp') || '');
    card.setAttribute('data-price-per', otpPrice);
    card.setAttribute('data-save-percent', card.getAttribute('data-save-percent-otp') || '');

    var priceEl = qs('[data-ag-pb-pd-variant-price-amount]', card);
    var compareEl = qs('[data-ag-pb-pd-variant-compare]', card);
    if (priceEl) priceEl.textContent = otpPrice;
    if (compareEl) {
      compareEl.textContent = otpCompare;
      compareEl.hidden = !otpCompare;
    }
  }

  function syncFromCard(picker, card) {
    if (!picker || !card) return;

    var attr = function (name) {
      return (card.getAttribute(name) || '').trim();
    };

    var idInput = qs('[data-ag-pb-pd-form-id]', picker);
    var spInput = qs('[data-ag-pb-pd-form-sp]', picker);
    var variantId = attr('data-variant-id');
    var sellingPlan = attr('data-selling-plan');

    if (idInput && /^\d+$/.test(variantId)) idInput.value = variantId;
    if (spInput) spInput.value = /^\d+$/.test(sellingPlan) ? sellingPlan : '';

    var details = picker.closest('[data-ag-pb-product-details]') || document;
    var pct = parseInt(attr('data-save-percent'), 10);
    if (isNaN(pct)) pct = 0;

    var cards = qsa('[data-ag-pb-pd-variant-card]', picker);
    var optionIndex = cards.indexOf(card) + 1;

    var detail = {
      percent: pct,
      root: details,
      optionIndex: optionIndex,
      variantId: variantId,
      sellingPlan: /^\d+$/.test(sellingPlan) ? sellingPlan : '',
      priceTotal: attr('data-price-total'),
      compareTotal: attr('data-compare-total'),
      refillPrice: attr('data-refill-price'),
      refillCompare: attr('data-refill-compare'),
      refillDays: attr('data-refill-days'),
      renewalLine: attr('data-renewal-line'),
      available: !card.disabled
    };

    document.dispatchEvent(new CustomEvent('ag-pb-pd:save-percent', {
      detail: { percent: pct, root: details }
    }));

    document.dispatchEvent(new CustomEvent('ag-pb-pd:variant-change', {
      detail: detail
    }));
  }

  function initPicker(picker) {
    if (!picker || picker.dataset.agPbPdVariantsReady === 'true') return;
    var cards = qsa('[data-ag-pb-pd-variant-card]', picker);
    if (!cards.length) return;

    picker.dataset.agPbPdVariantsReady = 'true';

    if (isOtpMode()) {
      cards.forEach(applyOtpToCard);
    }

    function select(card) {
      cards.forEach(function (c) {
        var active = c === card;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      syncFromCard(picker, card);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { select(card); });
    });

    var initial = qs('[data-ag-pb-pd-variant-card].is-active', picker) || cards[0];
    select(initial);
  }

  function initAll(scope) {
    var root = scope || document;
    qsa('[data-ag-pb-pd-variants]', root).forEach(initPicker);
    if (root.matches && root.matches('[data-ag-pb-pd-variants]')) initPicker(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
